import React from 'react';
import { CHAPTERS } from '../mock';

export default function Chapters() {
  return (
    <section id="chapters" className="relative py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="label-mono text-[var(--accent)] mb-6" data-reveal>Field Manual</div>
        <h2 className="font-display text-[clamp(2rem,5vw,4rem)] max-w-4xl text-white" data-reveal>
          A four-chapter <span className="font-display-italic text-[#c3cbdb]">emergency</span>, written the same way every time.
        </h2>

        <div className="mt-24 flex flex-col gap-28">
          {CHAPTERS.map((c) => (
            <div key={c.num} className="grid lg:grid-cols-[0.9fr_1.2fr_0.7fr] gap-8 lg:gap-12 items-start" data-reveal>
              {/* Big number + kicker */}
              <div>
                <div className="font-display text-[clamp(5rem,12vw,11rem)] text-white leading-none">{c.num}</div>
                <div className="label-mono text-[var(--accent)] mt-2">{c.kicker}</div>
              </div>

              {/* Title + body */}
              <div className="lg:pt-4">
                <h3 className="font-display text-[clamp(1.7rem,3.4vw,2.9rem)] text-white">{c.title}</h3>
                <p className="mt-6 text-[var(--muted)] text-[15px] leading-relaxed max-w-lg">{c.body}</p>
              </div>

              {/* Signal card */}
              <div className="lg:pt-4">
                <div className="border border-[var(--line)] bg-[var(--card)] p-7 hover-card-lift relative overflow-hidden">
                  <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-[var(--accent)] to-transparent" />
                  <div className="label-mono text-[var(--muted)]">Signal</div>
                  <div className="font-display text-[clamp(2.4rem,5vw,3.4rem)] text-[var(--accent)] mt-4">{c.signalValue}</div>
                  <div className="mt-4 text-[13px] text-[var(--muted)]">{c.signalLabel}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
